/**
 * Sticky ATC Bar
 * Slides up from the bottom when the main ATC button scrolls out of view.
 * Updates price display when the selected variant changes.
 */
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-atc-bar');
  if (!stickyBar) return;

  const form = document.querySelector('form[id^="product-form-"]');
  const mainAtcBtn = form && form.querySelector('.add-to-cart-btn');
  if (!mainAtcBtn) return;

  const priceEls = stickyBar.querySelectorAll('.sticky-atc-price');

  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (Number.isInteger(dollars) ? dollars.toFixed(2) : dollars.toFixed(2));
  }

  function getCurrentPrice() {
    const selectedVariant = form.querySelector('input[name="variant"]:checked');
    if (!selectedVariant) return 0;

    const subscribeSelected = form.querySelector('input[name="selling_plan_group"]:checked');
    if (subscribeSelected && subscribeSelected.value === 'subscribe') {
      // Try to read subscription price from the visible option-price span
      const subOption = form.querySelector('label:has(input[value="subscribe"]) .option-price');
      if (subOption) {
        const discounted = subOption.querySelector('.discounted-price');
        const text = (discounted || subOption).textContent.trim();
        // Strip non-numeric except decimal point
        const num = parseFloat(text.replace(/[^0-9.]/g, ''));
        if (!isNaN(num)) return Math.round(num * 100);
      }
    }

    return parseInt(selectedVariant.dataset.price || '0', 10);
  }

  function updatePrice() {
    const formatted = formatMoney(getCurrentPrice());
    priceEls.forEach(el => { el.textContent = formatted; });
  }

  // Show / hide bar based on ATC button visibility, accounting for fixed header
  function getHeaderBottom() {
    const headerMargin = document.querySelector('.header-margin-content');
    const header = document.getElementById('shopify-section-header');
    const el = headerMargin || header;
    return el ? el.getBoundingClientRect().bottom + 120 : 0;
  }

  function checkVisibility() {
    const btnRect = mainAtcBtn.getBoundingClientRect();
    const hidden = btnRect.bottom <= getHeaderBottom();
    stickyBar.classList.toggle('is-visible', hidden);
    stickyBar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
  }

  window.addEventListener('scroll', checkVisibility, { passive: true });
  checkVisibility();

  // Keep price in sync with variant selection
  form.querySelectorAll('input[name="variant"]').forEach(function (radio) {
    radio.addEventListener('change', updatePrice);
  });

  // Also update when subscribe/one-time toggle changes
  form.querySelectorAll('input[name="selling_plan_group"]').forEach(function (radio) {
    radio.addEventListener('change', updatePrice);
  });

  // Also update when the subscription frequency/plan dropdown changes
  const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', updatePrice);
  }

  updatePrice();

  // Mirror preorder CTA text from the main button into the sticky bar
  const preorderCta = document.getElementById('preorder-cta');
  const ctaTextEls = stickyBar.querySelectorAll('.sticky-atc-cta-text');

  function syncCtaText() {
    const text = preorderCta ? preorderCta.textContent.trim().toUpperCase() : 'ADD TO CART';
    ctaTextEls.forEach(function (el) { el.textContent = text; });
  }

  if (preorderCta) {
    new MutationObserver(syncCtaText).observe(preorderCta, { childList: true, characterData: true, subtree: true });
  }

  syncCtaText();

  const stickyTriggers = stickyBar.querySelectorAll('.sticky-atc-trigger');

  // Mirror the main ATC button's disabled/sold-out state onto the sticky bar
  function syncDisabledState() {
    stickyTriggers.forEach(function (btn) {
      btn.disabled = mainAtcBtn.disabled;
    });
  }

  new MutationObserver(syncDisabledState).observe(mainAtcBtn, {
    attributes: true,
    attributeFilter: ['disabled'],
  });

  syncDisabledState();

  // Proxy clicks to the main ATC button so all existing handlers run
  stickyTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      mainAtcBtn.click();
    });
  });

  // Hide sticky bar while the Rebuy side cart is open
  let cartOpen = false;

  function updateStickyVisibility() {
    if (cartOpen) {
      stickyBar.classList.remove('is-visible');
    } else {
      checkVisibility();
    }
  }

  document.addEventListener('rebuy:cart.open', function () {
    cartOpen = true;
    updateStickyVisibility();
  });

  document.addEventListener('rebuy:cart.close', function () {
    cartOpen = false;
    updateStickyVisibility();
  });

  // Watch <body> for Rebuy's "rebuy-cart-visible" class
  new MutationObserver(function () {
    let isOpen = document.body.classList.contains('rebuy-cart-visible');
    if (isOpen !== cartOpen) {
      cartOpen = isOpen;
      updateStickyVisibility();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
});
